
$(document).ready(function () {
  $(".new-cart-qty-error").hide();
  $(".new-cart-size-qty-label").hide();

  $(".new_cart_edit_button").click(function() {
    $('.bold_option_edit_container').removeClass('disable_bold_option');
    $(".loader").css('display','block');
    $(this).parents('.cart_row_item').find(".new-cart-qty-input-box" ).empty();
    $(this).parents('.cart_row_item').find(".bold_cart_edit_button").trigger( "click" );
    $(".new_cart_edit_button ").css("display","block");
    $(this).css('display','none');
    $(this).parents('.cart_row_item').find(".bold_cart_edit_button").hide();
    $(this).next(".bold_cart_edit_button").css("display","none");
    var loopId = $(this).parents('.cart_row_item').attr('id').split("cart_row_item_")[1];
    var str = $(this).parents('.cart_row_item').find('.three-quarters').html();
    var str1 = str.split("<br>");
    var i,j
    for(i=0;i<str1.length;i++){
      if($.trim(str1[i]).indexOf('Size Info:') != -1 ){
      var size_val = $.trim(str1[i]);
        size_val = $.trim(size_val.split(":")[1]);
      }
    }
   $(".new_cart_size-qty-label").addClass('disactive');
   $(this).parents('.cart_row_item').find(".new_cart_size_qty_"+loopId).removeClass('disactive');
    setTimeout(function(){
      $(".js-qty__num").val(0);
      if(typeof $("[name='properties[Size]']")[0] != "undefined"){
        $($("[name='properties[Size]'] > option ")).each(function () { 
           $(this).next(".new_cart_size-qty-label").children('label').css("display","block");
           $("[name='properties[Size]']").parent().parent('label').hide();
            if(this.value != '') {
              $(this).parents('.cart_row_item').find(".new-cart-qty-input-box" ).append('<div class="qty-input"><div class="qty-name">'+this.text+'</div><div class="value-button vlb-dec"  onclick="cartDecreaseValue(this,'+loopId+')" value="Decrease Value">-</div><input type="number" class="size-qty" id="number" value="0" readonly /><div class="value-button vlb-inc" onclick="cartIncreaseValue(this,'+loopId+')" value="Increase Value" >+</div></div>');
              $(".product__quantity").hide();
            }
        });
      }else{
        $('#cart_row_item_'+loopId+' .qty_div').css('display','block');
      }
      
      if(size_val){
        
        $('.bold_options_edit_in_cart').append('<input id="cart-size-info" type="text" name="properties[Size Info]" value="'+size_val+'">');
        var split_size_val = size_val.split(", ");
        var count_qty = 0;
        for(j=0;j<split_size_val.length;j++){ 
          var size_array = split_size_val[j];
          $('.qty-name').each(function() {
            var perSize = size_array.split("-");
            if(perSize.length > 2){
              var size = perSize[0]+'-'+perSize[1];
              var sizeVal = perSize[2];
            }else{
              var size = perSize[0];
              var sizeVal = perSize[1];
            }
            if($(this).text() == size){
               $(this).next().next().val(sizeVal);
               count_qty = parseInt(count_qty)+ parseInt(sizeVal);
             }
         });
        }
      $('.cart__product-qty_'+loopId).remove();
        for (i = 0; i < loopId; i++) {
            $('.bold_options_edit_in_cart').append('<input type="hidden" name="updates[]" class="new_cart__product-qty_'+loopId+'" value="'+count_qty+'">');
          }
      $('.bold_options_edit_in_cart').append('<input type="hidden" name="updates[]"  class="new_cart__product-qty_'+loopId+'" value="'+count_qty+'">');
    } 
      if($('.bold_option_uploadfile').length == 1 && $('#cart_qty_update_'+loopId).length == 0){
        	$('<button type="button" class="cart_qty_update" id="cart_qty_update_'+loopId+'" onclick="qty_update_btn_click('+loopId+')">Update Qty</button></div>').insertAfter( "#cart_row_item_"+loopId+" .new-cart-qty-input-box" );
      }
      $(".loader").css('display','none');
   
    },1500);
    
    $(this).parents('.cart_row_item').find(".bold_option_edit_container").children('div').children('button').first().addClass('cart_update_btn');
    $(this).parents('.cart_row_item').find(".bold_option_edit_container").children('div').children('button').last().remove();
    $(this).parents('.cart_row_item').find(".cart_update_btn").after('<button type="button" class="cart_cancel_btn" id="cart_cancel_btn_'+loopId+'" onclick="cancel_btn_click('+loopId+')">Cancel</button>');
    //$(this).parents('.cart_row_item').find(".cart_update_btn").after('<input class="cart_cancel_btn styled" type="button" value="Cancel" id="cart_cancel_btn_'+loopId+'" onclick="cancel_btn_click(2);">');
    
  });

  
  $('.new-cart-qty-input-box .vlb-inc').click(function (){
        //cartIncreaseValue($(this));
        var val1 = $(this).prev().val();    
        var price = '{{ bold_variant_price | divided_by: 100.00 }}';
        price =  price.replace('$','');
        val1 = $(".js-qty__num").val();
        price1 = price * val1; 
    var extra_price =  $('select[name="properties[Add Rhinestones]"]').val();
        var extra_price_upgrade =  $('select[name="properties[Add Rhinestone Upgrade ]"]').val();
        var size_upgrade =  $('select[name="properties[Rhinestone Size]"] option:selected').text();
        if(extra_price == 'Yes') {
          var ext_price_str  = $('select[name="properties[Add Rhinestones]"] option:selected').text();
            var tempp = ext_price_str.split('$');
            var tempp2 = tempp[1].split('.');
            price1= price1 +(val1*tempp2[0]);
        }else if(extra_price_upgrade == 'Yes') {
          var ext_price_str  = $('select[name="properties[Add Rhinestone Upgrade ]"] option:selected').text();
            var tempp = ext_price_str.split('$');
            var tempp2 = tempp[1].split('.');
            price1= price1 +(val1*tempp2[0]);
        }else if(size_upgrade.indexOf('$') != -1) {
          var ext_price_str  = size_upgrade;
            var tempp = ext_price_str.split('$');
            var tempp2 = tempp[1].split('.');
            price1= price1 +(val1*tempp2[0]);
        }
        $(".product__price").html("$"+price1.toFixed(2)); 
      });
  
 
  
    $('.new-cart-qty-input-box .vlb-dec').click(function () {
        //cartDecreaseValue($(this));
        var val1 = $(this).next().val();    
        var price = '{{ bold_variant_price | divided_by: 100.00 }}';
        price =  price.replace('$','');
        val1 = $(".js-qty__num").val();
        if(val1 > 0)
        {
        price1 = price * val1; 
        
        var extra_price =  $('select[name="properties[Add Rhinestones]"]').val();
        var extra_price_upgrade =  $('select[name="properties[Add Rhinestone Upgrade ]"]').val();
        var size_upgrade =  $('select[name="properties[Rhinestone Size]"] option:selected').text();
            if(extra_price == 'Yes') {
                var ext_price_str  = $('select[name="properties[Add Rhinestones]"] option:selected').text();
                var tempp = ext_price_str.split('$');
                var tempp2 = tempp[1].split('.');
                price1= price1 +(val1*tempp2[0]);
            }else if(extra_price_upgrade == 'Yes') {
                var ext_price_str  = $('select[name="properties[Add Rhinestone Upgrade ]"] option:selected').text();
                var tempp = ext_price_str.split('$');
                var tempp2 = tempp[1].split('.');
                price1= price1 +(val1*tempp2[0]);
            }else if(size_upgrade.indexOf('$') != -1) {
              var ext_price_str  = size_upgrade;
              var tempp = ext_price_str.split('$');
              var tempp2 = tempp[1].split('.');
              price1= price1 +(val1*tempp2[0]);
          }
        $( ".product__price" ).html("$"+parseFloat(price1).toFixed(2));        
      }
      });
   
       
   }); 
  
  function qty_update_btn_click(loopid){
    $('#cart_row_item_'+loopid+' .cart_update_btn').trigger( "click" );
  }

  function cartIncreaseValue(ew,loopid) {
    
    var value = parseInt(ew.previousElementSibling.value, 10);
    value = isNaN(value) ? 0 : value;
    if($('.size-qty').length){
     value++;
    }
   ew.previousElementSibling.value = value;
    var value2 = parseInt($('.js-qty__num').val(), 10);
    value2 = isNaN(value2) ? 0 : value2;
    if($('.size-qty').length){
     value2++;
    }
    $('.js-qty__num').val(value2);
    var pro_qty = $('.new_cart__product-qty_'+loopid).val();
    var total_qty = parseInt(pro_qty)+1;
    $('.cart__product-qty_'+loopid).remove(); 
    $('.new_cart__product-qty_'+loopid).val(total_qty); 
    var persize = '';
    if(total_qty > 0){
      $('#cart_row_item_'+loopid+' .new-cart-qty-error').css({"display": "none"});
      $(".cart_update_btn").prop("disabled", false);
    }
    $('.size-qty').each(function (index) {
      if ( $(this).val() > 0) {
      persize = persize +$(this).siblings('.qty-name').text() +'-' + $(this).val() + ', ';
     }
    });
   persize = persize.substr(0,persize.length - 2 );
   $('#cart-size-info').val(persize);
   if($.trim($('#cart_row_item_'+loopid+' .cart__product-name').text()) == "Femme Flannel™ with Logo"){
   		//$('#cart_row_item_'+loopid+' .cart_update_btn').trigger( "click" );
    }
   
  }
  

  function cartDecreaseValue(ew,loopid) {
    
    var value = parseInt(ew.nextElementSibling.value, 10);
    if(value <= 0){
      return false;
    }
    value = isNaN(value) ? 0 : value;
    value < 1 ? value = 1 : '';
    if($('.size-qty').length){
     value--;
    }
    ew.nextElementSibling.value = value;
    var value2 = parseInt($('.js-qty__num').val(), 10);
    value2 = isNaN(value2) ? 0 : value2;
    if($('.size-qty').length){
      value2--;
    }
    $('.js-qty__num').val(value2);
    var pro_qty = $('.new_cart__product-qty_'+loopid).val();
    var total_qty = parseInt(pro_qty)-1;
    $('.cart__product-qty_'+loopid).remove(); 
    $('.new_cart__product-qty_'+loopid).val(total_qty); 
    if(total_qty == 0){
      $('#cart_row_item_'+loopid+' .new-cart-qty-error').css({"display": "block", "color": "red"});
      $(".cart_update_btn").prop("disabled", true);
    }
    var persize = '';
      $('.size-qty').each(function (index ) {
        if ( $(this).val() > 0) {
          persize = persize +$(this).siblings('.qty-name').text() +'-' + $(this).val() + ', ';
      }
     });
      persize = persize.substr(0,persize.length - 2 );
      $('#cart-size-info').val(persize);
    if($.trim($('#cart_row_item_'+loopid+' .cart__product-name').text()) == "Femme Flannel™ with Logo"){
   		//$('#cart_row_item_'+loopid+' .cart_update_btn').trigger( "click" );
    }
  }


    function cancel_btn_click(val){
      //alert('here');
      $('#cart_row_item_'+val).find('.bold_option_edit_container').addClass('disable_bold_option');
      $('#cart_row_item_'+val).find(".new_cart_size-qty-label").children('label').css("display","none");
      $('#cart_row_item_'+val).find(".new-cart-qty-input-box" ).empty();
      $('#cart_row_item_'+val).find("#cart_qty_update_"+val).remove();
    }